module.exports = __webpack_public_path__ + "static/apple_store-d5c9f1f5ab94d941878113db4869211f.svg";